import * as Yup from 'yup';
import { useFormik } from 'formik';

import { requiredMsg } from 'lib/constants/messages';

const PracticeAddressSchema = Yup.object().shape({
  address1: Yup.string().required(requiredMsg('Address')),
  city: Yup.string().required(requiredMsg('City')),
  state: Yup.mixed()
    .required(requiredMsg('State'))
    .test('is-option', requiredMsg('State'), (v) => !!(v && typeof v === 'object' && 'value' in v)),
  zipCode: Yup.string().required(requiredMsg('Zip code'))
});

export default function usePracticeAddressFormik(initialValues = {}, onSubmit = () => {}) {
  const formik = useFormik({
    initialValues: {
      address1: initialValues?.address1 ?? '',
      address2: initialValues?.address2 ?? '',
      city: initialValues?.city ?? '',
      state: initialValues?.state ?? '',
      zipCode: initialValues?.zipCode ?? ''
    },
    enableReinitialize: true,
    validationSchema: PracticeAddressSchema,
    onSubmit
  });

  return formik;
}
